import { IconButton } from "@circleco/compass/components/IconButton";
import { Menu } from "@circleco/compass/components/Menu";
import type { MenuOptions } from "@circleco/compass/components/Menu";

import { t } from "@/i18n-js/instance";

interface ConversationCardMenuProps {
  onOpenChange?: (open: boolean) => void;
  options: MenuOptions;
}

export const ConversationCardMenu = ({
  onOpenChange,
  options,
}: ConversationCardMenuProps) => (
  <Menu
    align="end"
    side="bottom"
    options={options}
    onOpenChange={onOpenChange}
    trigger={
      <IconButton
        icon="dot-menu"
        variant="ghost"
        size="sm"
        className="cursor-pointer"
        aria-label={t("actions")}
      />
    }
  />
);
